import React, { useContext } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { useFavorite } from 'src/hooks/useFavorite';
import { Product } from 'src/models/product/schema';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

type Props = {
  product: Product;
  section: string;
};

export const FavoriteButton: React.FC<Props> = ({ product, section }) => {
  const localeResources = useContext(I18nContext);
  const { isFavorite, onFavButtonClick } = useFavorite(1, product);
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, clickedSection: string) => {
    e.preventDefault();
    e.stopPropagation();
    onFavButtonClick(clickedSection);
  };

  return (
    <div className={styles.container} onClick={(e) => handleClick(e, section)}>
      <NextImage
        src={
          isFavorite
            ? '/kaimono/images/favorite/favoriteHeartFilled.svg'
            : '/kaimono/images/favorite/favoriteHeartEmpty.svg'
        }
        width={36}
        height={36}
        alt={localeResources.favorites.addToFavorite}
      />
    </div>
  );
};
